// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 85 ? "exceljs" : chunkId) + "." + {"85":"9b90fbfe","96":"dc68a039","102":"675b8872","247":"a69072cc","317":"2fc8b530","441":"fd673184","455":"a2811a35","511":"8c263973","692":"e2768ccd","801":"27dcad4d","915":"c6142efe"}[chunkId] + ".chunk.js";
};